/* Bóveda: «Arma tu regalo». Empaque, luego catálogo fácil o cualquier página de la tienda en modo regalo, luego tarjeta. */
(function () {
  var raiz = document.getElementById('bn-regalo');
  if (!raiz || !window.BNRegalo || !window.bnRegaloModo) return;
  var B = window.BNRegalo, M = window.bnRegaloModo, esc = B.esc, money = B.money;
  var CFG = JSON.parse(document.getElementById('bn-regalo-config').textContent);
  var POR_TANDA = 24, CON_OPCIONES = ['detox', 'plantilla-alumbre', 'dije', 'kit-natural'];
  var CHIPS = [['', 'Todos'], ['inciensos', 'Inciensos'], ['limpieza', 'Limpieza energética'], ['aromas', 'Velas y aromas'], ['piedras', 'Piedras y cristales'], ['pulseras', 'Pulseras y anillos'], ['dijes', 'Dijes'], ['cuidado', 'Cuidado personal'], ['infusiones', 'Infusiones'], ['mistico', 'Tarot y místico'], ['otros', 'Otros']];
  var JSON_H = { 'Content-Type': 'application/json', Accept: 'application/json' };

  var v = 'emp', vis = POR_TANDA, chip = '', q = '', carrito = null, tj = null, aviso = '', errorTj = '', enviando = false, hecho = null, hechoId = null, igual = null;
  var CAT = { lista: [], porId: {}, pagina: 0, error: false, listo: false };

  /* Catálogo */
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function categoria(p) {
    var y = norm(p.type), g = norm((p.tags || []).join('|'));
    if (p.template_suffix === 'dije' || /dijes|collares/.test(y)) return 'dijes';
    if (/pulseras|anillos/.test(y)) return 'pulseras';
    if (/incienso/.test(y)) return 'inciensos';
    if (/tarot|oraculo|pendulo/.test(y)) return 'mistico';
    if (/salvia|palo santo|bombita|sahumador|sahumerio|carbon|resina|aguas energ|pastillas 7|kits de ritual/.test(y)) return 'limpieza';
    if (/infusion|detox|estres|digest/.test(y) || /tes e infusiones/.test(g)) return 'infusiones';
    if (/velas|aceites esenciales|aromaterapia|brumas|esencias|perlas arom|difusor|flores/.test(y)) return 'aromas';
    if (/piedras|sets y figuras|cajas por signo/.test(y)) return 'piedras';
    if (/piel|rostro|cabello|jabon|desodorante|unguento|manteca|gua sha|dental|congestion|dolor|cuidado personal|afeitado/.test(y)) return 'cuidado';
    return 'otros'; /* ningún producto queda solo en «Todos» */
  }
  function cargar() {
    CAT.error = false;
    var n = CAT.pagina + 1;
    fetch(CFG.datos + '&page=' + n, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('datos');
      return r.text();
    }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').getElementById('bn-regalo-datos-json');
      var d = JSON.parse(el.textContent);
      d.products.forEach(function (p) {
        if (CAT.porId[p.id]) return;
        p._cat = categoria(p);
        p._busca = norm(p.title + ' ' + p.type);
        CAT.porId[p.id] = p;
        CAT.lista.push(p);
      });
      CAT.pagina = n;
      if (n < d.pages) cargar(); else CAT.listo = true;
      if (v === 'prod') pintarGrid();
    }).catch(function () {
      CAT.error = true;
      if (v === 'prod') pintarGrid();
    });
  }
  function conOpciones(p) { return CON_OPCIONES.indexOf(p.template_suffix) > -1 || p.variants.length > 1; }

  /* Lo que ya lleva el regalo, leído del carrito */
  function regaloActual() {
    var m = M.leer();
    return m && carrito ? B.regalos(carrito).filter(function (x) { return x.id === m.id; })[0] || null : null;
  }
  function lineasDe(pid) {
    var g = regaloActual();
    return g ? g.productos.filter(function (l) { return l.product_id === pid; }) : [];
  }
  function numero() { var m = M.leer(), g = regaloActual(); return g ? g.ver : carrito ? B.mayorNumero(carrito) + 1 : m ? m.num : 1; }
  function tituloRegalo() { var m = M.leer(), e = m && B.EMPAQUES[m.emp]; return 'Regalo ' + numero() + (e ? ' · ' + e.en : '') + ': qué lleva'; }
  function leer() { return B.leer().then(function (c) { carrito = c; return c; }); }
  function plural(n) { return n + ' producto' + (n === 1 ? '' : 's'); }

  /* Pantallas */
  function pasos(i) {
    return '<ol class="bnr-pasos">' + ['1. Empaque', '2. Qué lleva', '3. Tarjeta'].map(function (t, n) {
      return '<li class="' + (n <= i ? 'on' : '') + '">' + t + '</li>';
    }).join('') + '</ol>';
  }
  function mias() {
    var r = carrito ? B.regalos(carrito) : [];
    if (!r.length) return '';
    return '<div class="bnr-mias"><b>Ya en tu carrito</b>' + r.map(function (g) {
      return '<span class="bnr-chico">Regalo ' + g.ver + ' en ' + B.EMPAQUES[g.tipo].txt + ': ' + plural(g.cantidad) + ', tarjeta ' + esc(g.tarjeta || 'Sin tarjeta') +
        ' · <a href="?agregar=' + encodeURIComponent(g.id) + '">Agregar algo</a></span>';
    }).join('') + '</div>';
  }
  function ocasiones() {
    var o = String(CFG.ocasiones || '').split('·').map(function (t) { return t.trim(); }).filter(Boolean);
    return (o.length ? '<ul class="bnr-ocasiones">' + o.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' : '') +
      (CFG.corp ? '<a class="bnr-corp" href="' + esc(CFG.corpUrl) + '" target="_blank" rel="noopener">' + esc(CFG.corp) + '</a>' : '');
  }
  function pantallaEmpaque() {
    return '<div class="bnr-wrap"><div><h1>' + esc(CFG.titulo) + '</h1><p class="bnr-suave">Elige cómo va, qué lleva y su tarjeta. Nosotras lo armamos. Puedes hacer todos los que quieras, cada uno por separado.</p>' + ocasiones() + '</div>' +
      (aviso ? '<p class="bnr-aviso" role="status">' + esc(aviso) + '</p>' : '') + mias() + pasos(0) + '<h2>Regalo ' + numero() + ': cómo lo quieres</h2><div class="bnr-emp">' +
      ['caja', 'bolsa'].map(function (k) {
        var e = B.EMPAQUES[k], c = CFG.empaques[k];
        return '<button type="button" class="bnr-op" data-emp="' + k + '"><img src="' + esc(c.imagen) + '" alt="' + e.nombre + '"><div><b>' + e.en + '</b><span class="bnr-suave bnr-chico">' + money(c.precio) + '</span></div></button>';
      }).join('') + '</div><p class="bnr-suave bnr-chico">Sin límite de productos: tenemos cajas grandes. Los lazos pueden variar, siempre en colores de la marca.</p></div>';
  }
  function pantallaProductos() {
    var m = M.leer(), g = regaloActual();
    return '<div class="bnr-wrap bnr-wrap--ancho">' + pasos(1) + '<div><h2 class="bnr-tit-regalo"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#b8963e" d="M12 0C13 7 17 11 24 12C17 13 13 17 12 24C11 17 7 13 0 12C7 11 11 7 12 0Z"/></svg><span data-bnr-tit>' + esc(tituloRegalo()) + '</span></h2><p class="bnr-suave bnr-chico">Agrega aquí o navega por toda la tienda con el menú: lo que agregues entra a este regalo. <a href="/collections/all">Ir a la tienda</a></p>' +
      (g ? '' : '<button type="button" class="bnr-lnk" data-cambiar>Cambiar empaque</button>') + '</div>' +
      (aviso ? '<p class="bnr-aviso" role="status">' + esc(aviso) + '</p>' : '') +
      '<input type="search" class="bnr-buscar" id="bnr-q" placeholder="Busca un producto" aria-label="Busca un producto" value="' + esc(q) + '">' +
      '<div class="bnr-chips">' + CHIPS.map(function (c) { return '<button type="button" class="bnr-chip' + (chip === c[0] ? ' on' : '') + '" data-chip="' + c[0] + '">' + c[1] + '</button>'; }).join('') + '</div>' +
      '<div class="bnr-grid" id="bnr-grid"></div><div id="bnr-estado"></div></div>';
  }
  function pantallaTarjeta() {
    var g = regaloActual(), e = B.EMPAQUES[g.tipo];
    return '<div class="bnr-wrap">' + pasos(2) + '<div><h2>Elige su tarjeta</h2><p class="bnr-suave bnr-chico">Va incluida.</p></div><div class="bnr-tarjetas">' +
      B.TARJETAS.map(function (t) { return '<button type="button" class="bnr-tj' + (tj === t ? ' on' : '') + '" data-tj="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>' +
      '<div class="bnr-res"><span class="bnr-grupo">Regalo ' + g.ver + ' en ' + e.txt + '</span>' +
      g.filas.map(function (f) {
        var l = f.linea, op = f.con ? 'Con ' + f.con.charAt(0).toLowerCase() + f.con.slice(1) : (l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '');
        return '<div class="bnr-fila">' + (l.image ? '<img src="' + esc(l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="">' : '') + '<span class="n">' + f.cantidad + ' × ' + esc(l.product_title) + (op ? ' <span class="bnr-suave">(' + esc(op) + ')</span>' : '') + '</span><span class="z">' + money(f.total) + '</span></div>';
      }).join('') +
      '<div class="bnr-fila"><img src="' + esc(CFG.empaques[g.tipo].imagen) + '" alt=""><span class="n">' + e.nombre + '</span><span class="z">' + money(g.empaque ? g.empaque.final_line_price : 0) + '</span></div>' +
      '<div class="bnr-tot"><span>Total del regalo</span><span>' + money(g.total) + '</span></div>' +
      '<button type="button" class="bnr-lnk" data-seguir>Agregar más productos</button></div>' +
      (errorTj ? '<p class="bnr-error" role="alert">' + esc(errorTj) + '</p>' : '') + '</div>';
  }
  function pantallaListo() {
    return '<div class="bnr-wrap"><div><p class="bnr-listo">Todo quedó en tu carrito</p><h1>Regalo ' + hecho + ' listo</h1></div>' + mias() +
      (igual ? '<p class="' + (igual.ok ? 'bnr-aviso" role="status"' : 'bnr-error" role="alert"') + '>' + esc(igual.texto) + '</p>' : '') +
      '<div class="bnr-fila2"><button type="button" class="bnr-b" data-otro>Armar otro regalo</button><button type="button" class="bnr-b bnr-b--sec" data-igual>Hacer otro igual</button><a class="bnr-b bnr-b--sec" href="/cart">Ver carrito</a></div></div>';
  }

  /* Tarjetas de producto */
  function tarjetaHtml(p) {
    var lineas = lineasDe(p.id), ctrl, precio, en = lineas.reduce(function (s, l) { return s + l.quantity; }, 0);
    if (conOpciones(p)) {
      var precios = (p.solo ? [p.solo.price] : p.variants.map(function (x) { return x.price; }));
      var min = Math.min.apply(null, precios), varios = p.solo ? true : Math.max.apply(null, precios) !== min;
      precio = (varios ? 'Desde ' : '') + money(min);
      ctrl = (en ? '<span class="uni">En el regalo: ' + en + '</span>' : '') + '<a class="bnr-b bnr-b--sec bnr-b--chico" href="' + esc('/products/' + p.handle) + '">Elegir opciones</a>';
    } else {
      var vr = p.variants[0], l = lineas.filter(function (x) { return x.variant_id === vr.id; })[0];
      precio = money(vr.price);
      ctrl = l ? '<span class="uni">En el regalo</span><div class="bnr-cant"><button type="button" data-q="-1" data-key="' + esc(l.key) + '" data-n="' + l.quantity + '" aria-label="Quitar uno">−</button><span aria-live="polite">' + l.quantity + '</span><button type="button" data-q="1" data-key="' + esc(l.key) + '" data-n="' + l.quantity + '" aria-label="Agregar otro">+</button></div>'
        : '<button type="button" class="bnr-b bnr-b--sec bnr-b--chico" data-add="' + vr.id + '">Agregar</button>';
    }
    var url = esc('/products/' + p.handle);
    return '<article class="bnr-pr' + (en ? ' en' : '') + '" data-p="' + p.id + '">' +
      '<a href="' + url + '" tabindex="-1" aria-hidden="true">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="400" height="400">' : '<span class="bnr-sinfoto"></span>') + '</a>' +
      '<div class="in"><a class="t" href="' + url + '">' + esc(p.title) + '</a><span class="pz">' + precio + '</span>' + ctrl + '</div></article>';
  }
  function filtrada() {
    var w = norm(q).split(/\s+/).filter(Boolean);
    return CAT.lista.filter(function (p) {
      if (chip && p._cat !== chip) return false;
      return w.every(function (x) { return p._busca.indexOf(x) > -1; });
    });
  }
  var obs = null;
  function pintarGrid(forzar) {
    var g = document.getElementById('bnr-grid'), e = document.getElementById('bnr-estado');
    if (!g) return;
    var tit = raiz.querySelector('[data-bnr-tit]');
    if (tit) tit.textContent = tituloRegalo();
    var cam = regaloActual() && raiz.querySelector('[data-cambiar]');
    if (cam) cam.remove();
    var L = filtrada(), quiere = Math.min(vis, L.length);
    if (forzar || g.children.length !== quiere || g.getAttribute('data-f') !== chip + '§' + q) {
      g.innerHTML = L.slice(0, quiere).map(tarjetaHtml).join('');
      g.setAttribute('data-f', chip + '§' + q);
    }
    /* Al volver con Atrás: la misma altura, cuando ya están dibujados los productos que había. */
    if (yVolver !== null && (CAT.listo || L.length >= vis)) { window.scrollTo(0, yVolver); yVolver = null; }
    var h = '';
    if (CAT.error) h = '<p class="bnr-error" role="alert">No pudimos cargar ' + (CAT.lista.length ? 'todos los productos' : 'los productos') + '. <button type="button" class="bnr-lnk" data-reintentar>Reintentar</button></p>';
    else if (!CAT.listo && !L.length) h = '<p class="bnr-cargando">Cargando productos...</p>';
    else if (!L.length) h = '<p class="bnr-suave">No encontramos ese producto.</p>';
    if (L.length > quiere) h += '<p style="text-align:center;margin-top:1.6rem"><button type="button" class="bnr-b bnr-b--sec" id="bnr-mas" data-mas-productos>Ver más productos</button></p>';
    else if (!CAT.listo && !CAT.error && L.length) h += '<p class="bnr-cargando">Cargando más productos...</p>';
    e.innerHTML = h;
    var m = document.getElementById('bnr-mas');
    if (obs) obs.disconnect();
    if (m && 'IntersectionObserver' in window) {
      obs = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { vis += POR_TANDA; pintarGrid(); } }, { rootMargin: '400px' });
      obs.observe(m);
    }
  }

  /* Barra de la pantalla de tarjeta (en las demás manda la barra de toda la tienda) */
  var barraEl = document.createElement('div');
  barraEl.className = 'bnr-barra';
  barraEl.hidden = true;
  barraEl.innerHTML = '<div><div class="i" id="bnr-bi"></div><button class="bnr-b" id="bnr-bb" type="button"></button></div>';
  raiz.appendChild(barraEl);
  var bi = barraEl.querySelector('#bnr-bi'), bb = barraEl.querySelector('#bnr-bb');
  function barra() {
    var g = v === 'tj' ? regaloActual() : null;
    barraEl.hidden = !g;
    document.documentElement.classList.toggle('bn-en-tarjeta', !!g);
    if (!g) return;
    bi.innerHTML = '<b>' + money(g.total) + '</b><br>' + (tj ? 'Tarjeta: ' + esc(tj) : 'Elige una tarjeta');
    bb.textContent = enviando ? 'Guardando...' : 'Listo';
    bb.disabled = !tj || enviando;
  }
  bb.addEventListener('click', function () {
    var g = regaloActual();
    if (bb.disabled || !g || !g.empaque) return;
    enviando = true; errorTj = ''; barra();
    B.ponerTarjeta(g.empaque, tj).then(leer).then(function () {
      var r = regaloActual();
      if (!r || !r.empaque || r.tarjeta !== tj) throw new Error('tarjeta');
      enviando = false; hecho = r.ver; hechoId = r.id; igual = null;
      M.terminar();
      ir('listo', true);
    }).catch(function () {
      enviando = false;
      errorTj = 'No pudimos guardar la tarjeta. Intenta de nuevo.';
      pintar();
    });
  });

  function pintar() {
    var h = v === 'prod' ? pantallaProductos() : v === 'tj' ? pantallaTarjeta() : v === 'listo' ? pantallaListo() : pantallaEmpaque();
    var d = document.createElement('div');
    d.innerHTML = h;
    while (raiz.firstChild && raiz.firstChild !== barraEl) raiz.removeChild(raiz.firstChild);
    raiz.insertBefore(d.firstChild, barraEl);
    barra();
    if (v === 'prod') pintarGrid(true);
  }
  function url(destino) { try { history.replaceState({ bnr: 1 }, '', destino); } catch (e) {} }
  function ir(destino, sinUrl) {
    v = destino;
    if (!sinUrl) url(RUTA_V());
    else url(location.pathname);
    pintar();
    window.scrollTo(0, 0);
  }
  function RUTA_V() { return location.pathname + (v === 'tj' ? '?terminar=1' : ''); }

  raiz.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('button');
    if (!t || t === bb) return;
    var d = t.dataset;
    if ((d.add || d.q) && window.__bnRegaloOcupado) return; /* la barra está cambiando este regalo */
    if (d.emp) {
      var ok = M.iniciar({ id: B.nuevoId(), num: numero(), emp: d.emp });
      if (!ok) { aviso = 'Este navegador no deja guardar el regalo mientras navegas por la tienda. Sal del modo privado o prueba otro navegador. No agregamos nada a tu carrito.'; pintar(); return; }
      aviso = '';
      ir('prod');
      return;
    }
    if (t.hasAttribute('data-cambiar')) { M.terminar(); ir('emp'); return; }
    if (d.chip !== undefined) {
      chip = d.chip; vis = POR_TANDA;
      raiz.querySelectorAll('.bnr-chip').forEach(function (c) { c.classList.toggle('on', c === t); });
      pintarGrid();
      return;
    }
    if (d.add) { cambiarCantidad(t, fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: JSON_H, body: JSON.stringify({ items: [{ id: Number(d.add), quantity: 1 }] }) })); return; }
    if (d.q) { cambiarCantidad(t, fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: JSON_H, body: JSON.stringify({ id: d.key, quantity: Number(d.n) + Number(d.q) }) })); return; }
    if (d.tj) {
      tj = d.tj; errorTj = '';
      raiz.querySelectorAll('.bnr-tj').forEach(function (c) { c.classList.toggle('on', c === t); });
      barra();
      return;
    }
    if (t.hasAttribute('data-seguir')) { ir('prod'); return; }
    if (t.hasAttribute('data-otro')) { hecho = null; igual = null; ir('emp'); return; }
    if (t.hasAttribute('data-igual')) { otroIgual(t); return; }
    if (t.hasAttribute('data-reintentar')) { cargar(); pintarGrid(); return; }
    if (t.hasAttribute('data-mas-productos')) { vis += POR_TANDA; pintarGrid(); }
  });
  function otroIgual(boton) {
    if (enviando) return;
    enviando = true;
    igual = null;
    boton.textContent = 'Agregando...';
    boton.setAttribute('aria-busy', 'true');
    B.duplicar(hechoId).then(function (r) {
      igual = { ok: true, texto: 'Regalo ' + r.ver + ' agregado' };
    }, function (e) {
      igual = { texto: e.limite ? 'No hay suficientes unidades para otro igual' : 'No pudimos hacer otro igual. Revisa tu conexión e intenta de nuevo.' };
    }).then(leer).catch(function () {}).then(function () {
      enviando = false;
      if (v !== 'listo') return;
      pintar();
      var b = raiz.querySelector('[data-igual]');
      if (b) b.focus({ preventScroll: true });
    });
  }
  function cambiarCantidad(boton, pedido) {
    if (enviando) return;
    enviando = true;
    var pr = boton.closest('[data-p]');
    if (pr) pr.setAttribute('aria-busy', 'true');
    pedido.then(function (r) {
      if (!r.ok) aviso = 'No hay más unidades disponibles de ese producto.';
      return leer();
    }).catch(function () { aviso = 'No pudimos agregarlo. Revisa tu conexión e intenta de nuevo.'; }).then(function () {
      enviando = false;
      if (aviso) { pintar(); aviso = ''; return; }
      pintarGrid(true);
    });
  }
  /* Salir a un producto o a la tienda y volver deja la cuadrícula como estaba: filtro, búsqueda y altura. */
  var REJILLA = 'bn-regalo-rejilla', yVolver = null;
  window.addEventListener('pagehide', function () {
    var m = M.leer();
    if (!m || v !== 'prod') return;
    try { sessionStorage.setItem(REJILLA, JSON.stringify({ id: m.id, chip: chip, q: q, vis: vis, y: window.scrollY })); } catch (e) {}
  });
  function recuperarRejilla(m) {
    var s = null;
    try { s = JSON.parse(sessionStorage.getItem(REJILLA)); } catch (e) {}
    if (!s || s.id !== m.id) return;
    chip = s.chip || ''; q = s.q || ''; vis = s.vis || POR_TANDA;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') {
      yVolver = s.y || 0;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    }
  }
  /* Volver desde la memoria del navegador conserva todo menos el carrito, que pudo cambiar afuera. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    leer().then(function () { if (v === 'prod') pintarGrid(true); else if (v === 'emp' || v === 'listo') pintar(); }).catch(function () {});
  });
  var tq;
  raiz.addEventListener('input', function (ev) {
    if (ev.target.id !== 'bnr-q') return;
    q = ev.target.value;
    clearTimeout(tq);
    tq = setTimeout(function () { vis = POR_TANDA; pintarGrid(); }, 150);
  });

  /* Lo que cambie en otra parte (cajón, guardia) se refleja aquí. */
  function deFuera(ev) {
    var c = ev.detail && ev.detail.cart;
    if (!c || !Array.isArray(c.items) || enviando) return;
    carrito = c;
    if (v === 'prod') pintarGrid(true);
    else if (v === 'emp' || v === 'listo') pintar();
  }
  window.addEventListener('bn:regalo-cambio', deFuera);
  window.addEventListener('boveda:carrito-actualizado', deFuera);
  window.addEventListener('bn:regalo-modo', function () {
    if (!M.leer() && (v === 'prod' || v === 'tj')) { aviso = ''; v = 'emp'; url(location.pathname); pintar(); }
  });

  /* Arranque */
  var params = null;
  try { params = new URLSearchParams(location.search); } catch (e) {}
  var agregar = params && params.get('agregar'), terminar = params && params.get('terminar');
  leer().then(null, function () { carrito = null; }).then(function () {
    var g = agregar && carrito ? B.regalos(carrito).filter(function (x) { return x.id === agregar; })[0] : null;
    if (g) {
      if (!M.iniciar({ id: g.id, num: g.num, emp: g.tipo })) aviso = 'Este navegador no deja guardar el regalo mientras navegas por la tienda. Sal del modo privado o prueba otro navegador. No agregamos nada a tu carrito.';
    }
    url(location.pathname);
    var m = M.leer();
    if (m) recuperarRejilla(m);
    if (m && terminar && regaloActual()) {
      var t = regaloActual().tarjeta;
      tj = t && t !== B.POR_ELEGIR ? t : null;
      v = 'tj'; url(location.pathname + '?terminar=1');
    } else if (m) v = 'prod';
    else v = 'emp';
    pintar();
    cargar();
  });
})();
